import { ScreeningStatusChangedActivity } from "../types";
import {
  getScreeningStatusChangeDetails,
  getScreeningStatusChangeText
} from "../helpers";

export const ScreeningStatusChanged = ({
  activityItem
}: {
  activityItem: ScreeningStatusChangedActivity;
}) => (
  <>
    <p className="text-base font-bold text-content-1000">
      Screening status{" "}
      <span className="font-normal">
        {getScreeningStatusChangeText(activityItem.details)}
      </span>
    </p>
    {getScreeningStatusChangeDetails(activityItem.details).map((line) => (
      <p key={line} className="text-sm font-medium text-content-300 mt-1">
        {line}
      </p>
    ))}
  </>
);
